import actions from './actions';

let initState = {
    quickLinks: [],
    quickLinksToggle: false,
    quickLinksFactBox: '',
    quickLinksComponent: '',
    notificationLoader: false,
    notificationDetails: '',
    notificationError: '',
    editNotificationLoader: false,
    editNotificationDetails: '',
    editNotificationData: ''   
};

export default function commonReducer(state = initState, action) {
    switch (action.type) {
        case actions.QUICKLINKS_START: {
            return {
                ...state,
                quickLinks: [],
                quickLinksToggle: action.false,
                quickLinksFactBox: '',
                quickLinksComponent: ''
            };
        }
        case actions.QUICKLINKS_SUCCESS: {
            return {
                ...state,
                quickLinks: action.payload,
                quickLinksToggle: action.toggle,
                quickLinksFactBox: action.factBox,
                quickLinksComponent: action.component
            };
        }
        case actions.QUICKLINKS_FAILURE: {
            return {
                ...state,
                quickLinks: [],
                quickLinksToggle: false,
                quickLinksFactBox: '',
                quickLinksComponent: ''
            };
        }
        case actions.NOTIFICATION_START: {
            return {
                ...state,
                notificationLoader: true
            };
        }
        case actions.NOTIFICATION_SUCCESS: {
            return {
                ...state,
                notificationLoader: false,
                notificationDetails: action.payload
            };
        }
        case actions.NOTIFICATION_FAILURE: {
            return {
                ...state,
                notificationLoader: false,
                notificationError: action.message
            };
        }
        case actions.EDIT_NOTIFICATION_START: {
            return {
                ...state,
                editNotificationLoader: true,
                editNotificationDetails: '',
                editNotificationError: '',
                editNotificationData: '',
            };
        }
        case actions.EDIT_NOTIFICATION_SUCCESS: {
            return {
                ...state,
                editNotificationLoader: false,
                editNotificationDetails: action.payload,
                editNotificationError: '',
                editNotificationData: action.data,
            };
        }
        case actions.EDIT_NOTIFICATION_FAILURE: {
            return {
                ...state,
                editNotificationLoader: false,
                editNotificationDetails: '',
                editNotificationError: action.message,
                editNotificationData: '',
            };
        }      
        default:
            return state;
    }
}

